import axiosApiClient from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/users";

class UserService {
  fetchUserInfo = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/me`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { user } = response.data.data;
      return { user };
    } catch (err) {
      throw handleError(err, "Error occurred while fetching user's info.");
    }
  };

  addDailyCredits = async () => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/free-credits`);
      if (response.status !== 201) {
        throw new Error();
      }
      const { credits, lastFreeCredits } = response.data.data;
      return { credits, lastFreeCredits };
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while clamming daily free credits."
      );
    }
  };

  setUsername = async (body) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/set-username`,
        body
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { affiliateLink } = response.data.data;
      return { username: body.username, affiliateLink };
    } catch (err) {
      throw handleError(err, "Error occurred while setting username.");
    }
  };

  deleteAccount = async () => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/delete-account`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting account.");
    }
  };

  getReferralUsers = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/referral-earning`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching referral earnings");
    }
  };
}

const userService = new UserService();

export default userService;
